import { SpatialLevels } from "@station/domain/models/spatial-level.model.ts";
import type { SpatialLevelRepository } from "@station/domain/repositories/spatial-level.repository.ts";
import { stationsTypes } from "@station/station-types.di.ts";
import { inject, injectable } from "inversify";

@injectable()
export class SpatialLevelGetAllUseCase {
    constructor(
        @inject(stationsTypes.repositories.SpatialLevelRepository)
        private readonly spatialLevelRepository: SpatialLevelRepository,
    ) {}

    async execute(forceRemote = false): Promise<SpatialLevels> {
        if (!forceRemote) {
            const localSpatialLevels =
                this.spatialLevelRepository.spatialLevelsGetLocal();
            if (localSpatialLevels.count) {
                return localSpatialLevels;
            }
        }

        const spatialLevelResult = await this.spatialLevelRepository.getAll();

        if (spatialLevelResult.isErr()) {
            throw new Error("Error getting spatial levels");
        }

        this.spatialLevelRepository.spatialLevelsSetLocal(
            spatialLevelResult.value,
        );

        return spatialLevelResult.match(
            (spatialLevels) => spatialLevels,
            () => SpatialLevels.empty(),
        );
    }
}
